"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _layers = require("../../layers");

var _typography = require("../../typography");

var _icon = require("../../icon");

var _theme = require("../../theme");

var MenuOption =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(MenuOption, _React$PureComponent);

  function MenuOption() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MenuOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MenuOption)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      _this.props.onSelect();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyPress", function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        _this.props.onSelect();

        e.preventDefault();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(MenuOption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          children = _this$props.children,
          theme = _this$props.theme,
          appearance = _this$props.appearance,
          secondaryText = _this$props.secondaryText,
          isSelected = _this$props.isSelected;
      var themedClassName = theme.getMenuItemClassName(appearance, 'none');
      var textProps = isSelected ? {
        color: 'selected',
        fontWeight: 500,
        marginLeft: 16
      } : {
        marginLeft: 44
      };
      return _react.default.createElement(_layers.Pane, {
        id: id,
        role: "menuitemradio",
        tabIndex: 0,
        className: themedClassName,
        onClick: this.handleClick,
        onKeyPress: this.handleKeyPress,
        "data-isselectable": "true",
        "aria-checked": isSelected,
        height: 40,
        display: "flex",
        alignItems: "center"
      }, isSelected && _react.default.createElement(_icon.Icon, {
        "aria-hidden": true,
        color: "selected",
        icon: "tick",
        marginLeft: 16,
        marginRight: -4,
        size: 16,
        flexShrink: 0
      }), _react.default.createElement(_typography.Text, (0, _extends2.default)({}, textProps, {
        marginRight: 16,
        flex: 1
      }), children), secondaryText && _react.default.createElement(_typography.Text, {
        marginRight: 16,
        color: "muted"
      }, secondaryText));
    }
  }]);
  return MenuOption;
}(_react.default.PureComponent);

MenuOption.displayName = "MenuOption";
(0, _defineProperty2.default)(MenuOption, "propTypes", {
  /**
   * The id attribute of the menu option.
   */
  id: _propTypes.default.string,

  /**
   * Function that is called on click and enter/space keypress.
   */
  onSelect: _propTypes.default.func,

  /**
   * The icon before the label.
   */
  isSelected: _propTypes.default.bool,

  /**
   * The children of the component.
   */
  children: _propTypes.default.node,

  /**
   * Secondary text shown on the right.
   */
  secondaryText: _propTypes.default.node,

  /**
   * The default theme only supports one default appearance.
   */
  appearance: _propTypes.default.string.isRequired,

  /**
   * Theme provided by ThemeProvider.
   */
  theme: _propTypes.default.object.isRequired
});
(0, _defineProperty2.default)(MenuOption, "defaultProps", {
  appearance: 'default',
  isSelected: false,
  onClick: function onClick() {},
  onSelect: function onSelect() {},
  onKeyPress: function onKeyPress() {}
});

var _default = (0, _theme.withTheme)(MenuOption);

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tZW51L3NyYy9NZW51T3B0aW9uLmpzIl0sIm5hbWVzIjpbIk1lbnVPcHRpb24iLCJwcm9wcyIsIm9uU2VsZWN0IiwiZSIsImtleSIsInByZXZlbnREZWZhdWx0IiwiaWQiLCJjaGlsZHJlbiIsInRoZW1lIiwiYXBwZWFyYW5jZSIsInNlY29uZGFyeVRleHQiLCJpc1NlbGVjdGVkIiwidGhlbWVkQ2xhc3NOYW1lIiwiZ2V0TWVudUl0ZW1DbGFzc05hbWUiLCJ0ZXh0UHJvcHMiLCJjb2xvciIsImZvbnRXZWlnaHQiLCJtYXJnaW5MZWZ0IiwiaGFuZGxlQ2xpY2siLCJoYW5kbGVLZXlQcmVzcyIsIlJlYWN0IiwiUHVyZUNvbXBvbmVudCIsIlByb3BUeXBlcyIsInN0cmluZyIsImZ1bmMiLCJib29sIiwibm9kZSIsImlzUmVxdWlyZWQiLCJvYmplY3QiLCJvbkNsaWNrIiwib25LZXlQcmVzcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztJQUVNQSxVOzs7Ozs7Ozs7Ozs7Ozs7Ozs4RkE4Q1UsWUFBTTtBQUNsQixZQUFLQyxLQUFMLENBQVdDLFFBQVg7QUFDRCxLO2lHQUVnQixVQUFBQyxDQUFDLEVBQUk7QUFDcEIsVUFBSUEsQ0FBQyxDQUFDQyxHQUFGLEtBQVUsT0FBVixJQUFxQkQsQ0FBQyxDQUFDQyxHQUFGLEtBQVUsR0FBbkMsRUFBd0M7QUFDdEMsY0FBS0gsS0FBTCxDQUFXQyxRQUFYOztBQUNBQyxRQUFBQSxDQUFDLENBQUNFLGNBQUY7QUFDRDtBQUNGLEs7Ozs7Ozs2QkFFUTtBQUFBLHdCQVFILEtBQUtKLEtBUkY7QUFBQSxVQUVMSyxFQUZLLGVBRUxBLEVBRks7QUFBQSxVQUdMQyxRQUhLLGVBR0xBLFFBSEs7QUFBQSxVQUlMQyxLQUpLLGVBSUxBLEtBSks7QUFBQSxVQUtMQyxVQUxLLGVBS0xBLFVBTEs7QUFBQSxVQU1MQyxhQU5LLGVBTUxBLGFBTks7QUFBQSxVQU9MQyxVQVBLLGVBT0xBLFVBUEs7QUFVUCxVQUFNQyxlQUFlLEdBQUdKLEtBQUssQ0FBQ0ssb0JBQU4sQ0FBMkJKLFVBQTNCLEVBQXVDLE1BQXZDLENBQXhCO0FBRUEsVUFBTUssU0FBUyxHQUFHSCxVQUFVLEdBQ3hCO0FBQ0VJLFFBQUFBLEtBQUssRUFBRSxVQURUO0FBRUVDLFFBQUFBLFVBQVUsRUFBRSxHQUZkO0FBR0VDLFFBQUFBLFVBQVUsRUFBRTtBQUhkLE9BRHdCLEdBTXhCO0FBQUVBLFFBQUFBLFVBQVUsRUFBRTtBQUFkLE9BTko7QUFRQSxhQUNFLDZCQUFDLFlBQUQ7QUFDRSxRQUFBLEVBQUUsRUFBRVgsRUFETjtBQUVFLFFBQUEsSUFBSSxFQUFDLGVBRlA7QUFHRSxRQUFBLFFBQVEsRUFBRSxDQUhaO0FBSUUsUUFBQSxTQUFTLEVBQUVNLGVBSmI7QUFLRSxRQUFBLE9BQU8sRUFBRSxLQUFLTSxXQUxoQjtBQU1FLFFBQUEsVUFBVSxFQUFFLEtBQUtDLGNBTm5CO0FBT0UsNkJBQWtCLE1BUHBCO0FBUUUsd0JBQWNSLFVBUmhCO0FBU0UsUUFBQSxNQUFNLEVBQUUsRUFUVjtBQVVFLFFBQUEsT0FBTyxFQUFDLE1BVlY7QUFXRSxRQUFBLFVBQVUsRUFBQztBQVhiLFNBYUdBLFVBQVUsSUFDVCw2QkFBQyxVQUFEO0FBQ0UsMkJBREY7QUFFRSxRQUFBLEtBQUssRUFBQyxVQUZSO0FBR0UsUUFBQSxJQUFJLEVBQUMsTUFIUDtBQUlFLFFBQUEsVUFBVSxFQUFFLEVBSmQ7QUFLRSxRQUFBLFdBQVcsRUFBRSxDQUFDLENBTGhCO0FBTUUsUUFBQSxJQUFJLEVBQUUsRUFOUjtBQU9FLFFBQUEsVUFBVSxFQUFFO0FBUGQsUUFkSixFQXdCRSw2QkFBQyxnQkFBRCw2QkFBVUcsU0FBVjtBQUFxQixRQUFBLFdBQVcsRUFBRSxFQUFsQztBQUFzQyxRQUFBLElBQUksRUFBRTtBQUE1QyxVQUNHUCxRQURILENBeEJGLEVBMkJHRyxhQUFhLElBQ1osNkJBQUMsZ0JBQUQ7QUFBTSxRQUFBLFdBQVcsRUFBRSxFQUFuQjtBQUF1QixRQUFBLEtBQUssRUFBQztBQUE3QixTQUNHQSxhQURILENBNUJKLENBREY7QUFtQ0Q7OztFQWhIc0JVLGVBQU1DLGE7O0FBQXpCckIsVTs4QkFBQUEsVSxlQUNlO0FBQ2pCOzs7QUFHQU0sRUFBQUEsRUFBRSxFQUFFZ0IsbUJBQVVDLE1BSkc7O0FBTWpCOzs7QUFHQXJCLEVBQUFBLFFBQVEsRUFBRW9CLG1CQUFVRSxJQVRIOztBQVdqQjs7O0FBR0FiLEVBQUFBLFVBQVUsRUFBRVcsbUJBQVVHLElBZEw7O0FBZ0JqQjs7O0FBR0FsQixFQUFBQSxRQUFRLEVBQUVlLG1CQUFVSSxJQW5CSDs7QUFxQmpCOzs7QUFHQWhCLEVBQUFBLGFBQWEsRUFBRVksbUJBQVVJLElBeEJSOztBQTBCakI7OztBQUdBakIsRUFBQUEsVUFBVSxFQUFFYSxtQkFBVUMsTUFBVixDQUFpQkksVUE3Qlo7O0FBK0JqQjs7O0FBR0FuQixFQUFBQSxLQUFLLEVBQUVjLG1CQUFVTSxNQUFWLENBQWlCRDtBQWxDUCxDOzhCQURmM0IsVSxrQkFzQ2tCO0FBQ3BCUyxFQUFBQSxVQUFVLEVBQUUsU0FEUTtBQUVwQkUsRUFBQUEsVUFBVSxFQUFFLEtBRlE7QUFHcEJrQixFQUFBQSxPQUFPLEVBQUUsbUJBQU0sQ0FBRSxDQUhHO0FBSXBCM0IsRUFBQUEsUUFBUSxFQUFFLG9CQUFNLENBQUUsQ0FKRTtBQUtwQjRCLEVBQUFBLFVBQVUsRUFBRSxzQkFBTSxDQUFFO0FBTEEsQzs7ZUE2RVQsc0JBQVU5QixVQUFWLEMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgeyBQYW5lIH0gZnJvbSAnLi4vLi4vbGF5ZXJzJ1xuaW1wb3J0IHsgVGV4dCB9IGZyb20gJy4uLy4uL3R5cG9ncmFwaHknXG5pbXBvcnQgeyBJY29uIH0gZnJvbSAnLi4vLi4vaWNvbidcbmltcG9ydCB7IHdpdGhUaGVtZSB9IGZyb20gJy4uLy4uL3RoZW1lJ1xuXG5jbGFzcyBNZW51T3B0aW9uIGV4dGVuZHMgUmVhY3QuUHVyZUNvbXBvbmVudCB7XG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgLyoqXG4gICAgICogVGhlIGlkIGF0dHJpYnV0ZSBvZiB0aGUgbWVudSBvcHRpb24uXG4gICAgICovXG4gICAgaWQ6IFByb3BUeXBlcy5zdHJpbmcsXG5cbiAgICAvKipcbiAgICAgKiBGdW5jdGlvbiB0aGF0IGlzIGNhbGxlZCBvbiBjbGljayBhbmQgZW50ZXIvc3BhY2Uga2V5cHJlc3MuXG4gICAgICovXG4gICAgb25TZWxlY3Q6IFByb3BUeXBlcy5mdW5jLFxuXG4gICAgLyoqXG4gICAgICogVGhlIGljb24gYmVmb3JlIHRoZSBsYWJlbC5cbiAgICAgKi9cbiAgICBpc1NlbGVjdGVkOiBQcm9wVHlwZXMuYm9vbCxcblxuICAgIC8qKlxuICAgICAqIFRoZSBjaGlsZHJlbiBvZiB0aGUgY29tcG9uZW50LlxuICAgICAqL1xuICAgIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZSxcblxuICAgIC8qKlxuICAgICAqIFNlY29uZGFyeSB0ZXh0IHNob3duIG9uIHRoZSByaWdodC5cbiAgICAgKi9cbiAgICBzZWNvbmRhcnlUZXh0OiBQcm9wVHlwZXMubm9kZSxcblxuICAgIC8qKlxuICAgICAqIFRoZSBkZWZhdWx0IHRoZW1lIG9ubHkgc3VwcG9ydHMgb25lIGRlZmF1bHQgYXBwZWFyYW5jZS5cbiAgICAgKi9cbiAgICBhcHBlYXJhbmNlOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG5cbiAgICAvKipcbiAgICAgKiBUaGVtZSBwcm92aWRlZCBieSBUaGVtZVByb3ZpZGVyLlxuICAgICAqL1xuICAgIHRoZW1lOiBQcm9wVHlwZXMub2JqZWN0LmlzUmVxdWlyZWRcbiAgfVxuXG4gIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgYXBwZWFyYW5jZTogJ2RlZmF1bHQnLFxuICAgIGlzU2VsZWN0ZWQ6IGZhbHNlLFxuICAgIG9uQ2xpY2s6ICgpID0+IHt9LFxuICAgIG9uU2VsZWN0OiAoKSA9PiB7fSxcbiAgICBvbktleVByZXNzOiAoKSA9PiB7fVxuICB9XG5cbiAgaGFuZGxlQ2xpY2sgPSAoKSA9PiB7XG4gICAgdGhpcy5wcm9wcy5vblNlbGVjdCgpXG4gIH1cblxuICBoYW5kbGVLZXlQcmVzcyA9IGUgPT4ge1xuICAgIGlmIChlLmtleSA9PT0gJ0VudGVyJyB8fCBlLmtleSA9PT0gJyAnKSB7XG4gICAgICB0aGlzLnByb3BzLm9uU2VsZWN0KClcbiAgICAgIGUucHJldmVudERlZmF1bHQoKVxuICAgIH1cbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7XG4gICAgICBpZCxcbiAgICAgIGNoaWxkcmVuLFxuICAgICAgdGhlbWUsXG4gICAgICBhcHBlYXJhbmNlLFxuICAgICAgc2Vjb25kYXJ5VGV4dCxcbiAgICAgIGlzU2VsZWN0ZWRcbiAgICB9ID0gdGhpcy5wcm9wc1xuXG4gICAgY29uc3QgdGhlbWVkQ2xhc3NOYW1lID0gdGhlbWUuZ2V0TWVudUl0ZW1DbGFzc05hbWUoYXBwZWFyYW5jZSwgJ25vbmUnKVxuXG4gICAgY29uc3QgdGV4dFByb3BzID0gaXNTZWxlY3RlZFxuICAgICAgPyB7XG4gICAgICAgICAgY29sb3I6ICdzZWxlY3RlZCcsXG4gICAgICAgICAgZm9udFdlaWdodDogNTAwLFxuICAgICAgICAgIG1hcmdpbkxlZnQ6IDE2XG4gICAgICAgIH1cbiAgICAgIDogeyBtYXJnaW5MZWZ0OiA0NCB9XG5cbiAgICByZXR1cm4gKFxuICAgICAgPFBhbmVcbiAgICAgICAgaWQ9e2lkfVxuICAgICAgICByb2xlPVwibWVudWl0ZW1yYWRpb1wiXG4gICAgICAgIHRhYkluZGV4PXswfVxuICAgICAgICBjbGFzc05hbWU9e3RoZW1lZENsYXNzTmFtZX1cbiAgICAgICAgb25DbGljaz17dGhpcy5oYW5kbGVDbGlja31cbiAgICAgICAgb25LZXlQcmVzcz17dGhpcy5oYW5kbGVLZXlQcmVzc31cbiAgICAgICAgZGF0YS1pc3NlbGVjdGFibGU9XCJ0cnVlXCJcbiAgICAgICAgYXJpYS1jaGVja2VkPXtpc1NlbGVjdGVkfVxuICAgICAgICBoZWlnaHQ9ezQwfVxuICAgICAgICBkaXNwbGF5PVwiZmxleFwiXG4gICAgICAgIGFsaWduSXRlbXM9XCJjZW50ZXJcIlxuICAgICAgPlxuICAgICAgICB7aXNTZWxlY3RlZCAmJiAoXG4gICAgICAgICAgPEljb25cbiAgICAgICAgICAgIGFyaWEtaGlkZGVuXG4gICAgICAgICAgICBjb2xvcj1cInNlbGVjdGVkXCJcbiAgICAgICAgICAgIGljb249XCJ0aWNrXCJcbiAgICAgICAgICAgIG1hcmdpbkxlZnQ9ezE2fVxuICAgICAgICAgICAgbWFyZ2luUmlnaHQ9ey00fVxuICAgICAgICAgICAgc2l6ZT17MTZ9XG4gICAgICAgICAgICBmbGV4U2hyaW5rPXswfVxuICAgICAgICAgIC8+XG4gICAgICAgICl9XG4gICAgICAgIDxUZXh0IHsuLi50ZXh0UHJvcHN9IG1hcmdpblJpZ2h0PXsxNn0gZmxleD17MX0+XG4gICAgICAgICAge2NoaWxkcmVufVxuICAgICAgICA8L1RleHQ+XG4gICAgICAgIHtzZWNvbmRhcnlUZXh0ICYmIChcbiAgICAgICAgICA8VGV4dCBtYXJnaW5SaWdodD17MTZ9IGNvbG9yPVwibXV0ZWRcIj5cbiAgICAgICAgICAgIHtzZWNvbmRhcnlUZXh0fVxuICAgICAgICAgIDwvVGV4dD5cbiAgICAgICAgKX1cbiAgICAgIDwvUGFuZT5cbiAgICApXG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgd2l0aFRoZW1lKE1lbnVPcHRpb24pXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/menu/src/MenuOption.js
// module id = 78
// module chunks = 0